__turbopack_context__.v({
  "border": "raycast-module__2WAhyG__border",
  "dialogIn": "raycast-module__2WAhyG__dialogIn",
  "dialogOut": "raycast-module__2WAhyG__dialogOut",
  "loading": "raycast-module__2WAhyG__loading",
  "raycast": "raycast-module__2WAhyG__raycast",
  "raycast-submenu": "raycast-module__2WAhyG__raycast-submenu",
  "shine": "raycast-module__2WAhyG__shine",
  "showTopShine": "raycast-module__2WAhyG__showTopShine",
  "slideIn": "raycast-module__2WAhyG__slideIn",
  "slideOut": "raycast-module__2WAhyG__slideOut",
});
